import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function getAllRolesByProjectCode(projectCode, callback) {
	if (projectCode) {
		firebaseRef
			.ref('/kavtek_roles/' + projectCode)
			.on('value', (snapshot) => {
				var rolesParent = snapshot.val();

				if (rolesParent) {
					//there is a parent role
					var rolesParentKeys = Object.keys(rolesParent);

					var rolesArr = [];

					rolesParentKeys.forEach((role) => {
						var roles = rolesParent[role];

						console.log('getAllRoles roles', roles);

						var roleObj = {
							roleId: roles.roleId,
							roleName: roles.roleName,
							roleAccessibilities: roles.accessibilities,
							roleColor: roles.color
						};

						rolesArr.push(roleObj);
					});

					console.log('getAllRoles rolesArr', rolesArr);

					callback(rolesArr);
				} else {
					//there is no parent role - lets set redux to empty state
					callback([]);
				}
			});
	} else {
		callback([]);
	}
}

export async function getAllRoles(callback) {
	firebaseRef.ref('/kavtek_roles/').on('value', (snapshot) => {
		let roles = [];
		let rolesParent = snapshot.val();
		if (rolesParent) {
			for (let projectCode in rolesParent) {
				let roleArr = Object.values(rolesParent[projectCode]);
				roles = [...roles, ...roleArr];
			}
		}
		callback(roles);
	});
}
